import { useState } from 'react';
import '../App.css';
import EURouletteInfo from './EURouletteInfo';
import EUTable from './EUTable';

function EURoulette() {

    return (
        <div className='h-full flex'>
            <EURouletteInfo />
            <EUTable />
        </div>
    );
}

export default EURoulette;